<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-tab-group>
  <mat-tab label="Create">
  <p>{{data.message}}</p>
  <form [formGroup]="dosageTypeForm">
    <p>
        <mat-form-field appearance="outline">
            <mat-label>Unit</mat-label>
            <mat-select required formControlName="dosageUnit">
                <mat-option *ngFor="let unit of dosageUnits" [value]="unit">
                    {{unit.unit}}
                </mat-option>
            </mat-select>
            <button type="button" matSuffix mat-icon-button (click)="createDosageUnit($event)">
                <mat-icon>add</mat-icon>
            </button>
            <mat-error *ngIf="dosageTypeForm.get('dosageUnit')?.invalid">
                Dosage unit is invalid
            </mat-error>
        </mat-form-field>
    </p>
    <p>
        <mat-form-field appearance="outline">
            <mat-label>Dosage type</mat-label>
            <input required formControlName="type" type="text" matInput placeholder="Dosage type">
            <mat-error *ngIf="dosageTypeForm.get('type')?.invalid">
                Dosage type is invalid
            </mat-error>
        </mat-form-field>
    </p>
    <p>
        <mat-form-field appearance="outline">
            <mat-label>Code</mat-label>
            <input required formControlName="code" type="text" matInput placeholder="Code">
            <mat-error *ngIf="dosageTypeForm.get('code')?.invalid">
                Code is invalid
            </mat-error>
        </mat-form-field>
    </p>
</form>
</mat-tab>
<mat-tab label="Manage units">
    <div class="mt-2" *ngFor="let unit of dosageUnits">
        <div class="row">
            <p class="col-md-8">{{unit.unit}}</p>
            <p class="col-md-4 text-end">
                <button (click)="deleteDosageUnit(unit)" mat-flat-button color="warn">Delete</button>
            </p>
        </div>
        <div class="py-2">
            <mat-divider></mat-divider>
        </div>
    </div>
</mat-tab>
</mat-tab-group>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button [disabled]="!dosageTypeForm.valid" mat-raised-button  color="primary" (click)="createDosageType()">Create</button>
</div>
